import { createSelector } from '@reduxjs/toolkit'
import { DateTime } from 'luxon'
import { BookingRefundPolicy } from '@/models/license'
import { insertPeriodSlice } from '@/store/insertPeriodSlice'
import { REFUND_POLICY_DAYS_MAP } from '@/utils/bookingRefundPolicy'
import { licenseSlice } from '..'

export const isBookingRefundableSelector = createSelector(
  [licenseSlice.selectors.license, insertPeriodSlice.selectors.period],
  (license, period): boolean => {
    if (
      !license ||
      !period ||
      typeof license.bookingRefundPolicy !== 'number' ||
      license.bookingRefundPolicy === BookingRefundPolicy.NEVER
    ) {
      return false
    }

    const start = DateTime.fromISO(period.start)
    const now = DateTime.now().startOf('day')

    return (
      REFUND_POLICY_DAYS_MAP[license.bookingRefundPolicy] <=
      start.diff(now, 'days').days
    )
  }
)
